import { useTranslation } from "react-i18next";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  LabelList,
  Cell,
} from "recharts";
import { VIZ } from "../../css/brandTokens";
import { fmt } from "./fmt";
import "../../css/dashboardIA.css";

// Embudo de 5 pasos (RF-10/RF-11). El valor va FUERA de la barra (LabelList position="right"): los pasos
// claros de la rampa (VIZ.rampa[0]/[1]) no dan contraste para texto blanco encima. La fuga entre
// escalones es el dato del bloque — sin ella el embudo es decorativo (RF-11) — así que se pinta como una
// lista de líneas debajo del chart, cada una con la conversión (paso ÷ paso anterior).
const Embudo = ({ pasos, height = 220 }) => {
  const [t] = useTranslation("dashboardIA");

  const datos = (pasos || []).map((paso) => ({
    ...paso,
    NombrePaso: t(`dashboardIA_embudo_paso_${paso.Paso}`),
  }));

  return (
    <div>
      <ResponsiveContainer width="100%" height={height}>
        <BarChart data={datos} layout="vertical" margin={{ top: 4, right: 48, left: 4, bottom: 4 }}>
          <CartesianGrid stroke={VIZ.grid} horizontal={false} />
          <XAxis type="number" hide />
          <YAxis
            type="category"
            dataKey="NombrePaso"
            width={140}
            stroke={VIZ.axis}
            tickLine={false}
            tick={{ fill: VIZ.ink2, fontSize: 12 }}
          />
          <Tooltip
            cursor={{ fill: "rgba(17,17,19,.05)" }}
            contentStyle={{ borderRadius: 8, borderColor: VIZ.grid, fontSize: 13 }}
          />
          <Bar dataKey="Valor" radius={[0, 4, 4, 0]} maxBarSize={26}>
            {datos.map((entrada, indice) => (
              <Cell key={entrada.Paso} fill={VIZ.rampa[indice % VIZ.rampa.length]} />
            ))}
            <LabelList dataKey="Valor" position="right" style={{ fill: VIZ.ink, fontSize: 13, fontWeight: 700 }} />
          </Bar>
        </BarChart>
      </ResponsiveContainer>

      <ul className="dia-embudo__fugas">
        {datos.slice(1).map((paso, indice) => {
          const anterior = datos[indice];
          const fuga = Math.max(0, (anterior.Valor || 0) - (paso.Valor || 0));
          const conversion = anterior.Valor > 0 ? Math.round((paso.Valor / anterior.Valor) * 100) : null;
          const pctTexto = conversion === null ? fmt(null) : `${conversion}%`;
          return (
            <li key={paso.Paso}>
              {t("dashboardIA_embudo_fuga", {
                fuga,
                deLabel: anterior.NombrePaso,
                aLabel: paso.NombrePaso,
              })}
              {" — "}
              {t("dashboardIA_embudo_conversion", { pct: pctTexto })}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default Embudo;
